'use client'
import { createContext } from 'react'
import type { PublicOfferPage } from './PublicOfferTabs'

export const PublicEntryChromeContext = createContext<null | {
    registerRedirect: (url: string) => () => void
    /** Lets a details page mark its own offer tab, which its path alone does not tell. */
    registerOfferPage: (page: PublicOfferPage) => () => void
}>(null)
